/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  HTTPValidationError,
  ListSessionsApiTrainingAgentSessionsGetParams,
  StreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetParams,
  TrainingAgentDecision,
  TrainingAgentEventView,
  TrainingAgentLaunchDecision,
  TrainingAgentMessageCreate,
  TrainingAgentSessionCreate,
  TrainingAgentSessionView,
  TrainingAgentSessionsResponse,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type createSessionApiTrainingAgentSessionsPostResponse201 = {
  data: TrainingAgentSessionView;
  status: 201;
};

export type createSessionApiTrainingAgentSessionsPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createSessionApiTrainingAgentSessionsPostResponseSuccess =
  createSessionApiTrainingAgentSessionsPostResponse201 & {
    headers: Headers;
  };
export type createSessionApiTrainingAgentSessionsPostResponseError =
  createSessionApiTrainingAgentSessionsPostResponse422 & {
    headers: Headers;
  };

export type createSessionApiTrainingAgentSessionsPostResponse =
  | createSessionApiTrainingAgentSessionsPostResponseSuccess
  | createSessionApiTrainingAgentSessionsPostResponseError;

export const getCreateSessionApiTrainingAgentSessionsPostUrl = () => {
  return `/api/training-agent/sessions`;
};

/**
 * Staff only: open a session for the team and start its runner Job.
 *
 * 409 while the team has a live session (the partial unique index
 * decides). A live session whose Job is gone is failed first, so it
 * cannot block this one. The Job is created before the session commits:
 * until then no other request can see the row, so none can mistake the
 * Job still being created for one that is gone, and a second create for
 * the team waits on the unique index and then gets its 409.
 * @summary Create Session
 */
export const createSessionApiTrainingAgentSessionsPost = async (
  trainingAgentSessionCreate: TrainingAgentSessionCreate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<createSessionApiTrainingAgentSessionsPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<createSessionApiTrainingAgentSessionsPostResponse>(
    getCreateSessionApiTrainingAgentSessionsPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(trainingAgentSessionCreate),
    },
  );
};

export const getCreateSessionApiTrainingAgentSessionsPostMutationKey = () =>
  ["createSessionApiTrainingAgentSessionsPost"] as const;

export const getCreateSessionApiTrainingAgentSessionsPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSessionApiTrainingAgentSessionsPost>>,
    TError,
    CreateSessionApiTrainingAgentSessionsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSessionApiTrainingAgentSessionsPost>>,
  TError,
  CreateSessionApiTrainingAgentSessionsPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreateSessionApiTrainingAgentSessionsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSessionApiTrainingAgentSessionsPost>>,
    CreateSessionApiTrainingAgentSessionsPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createSessionApiTrainingAgentSessionsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSessionApiTrainingAgentSessionsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createSessionApiTrainingAgentSessionsPost>>
  >;
export type CreateSessionApiTrainingAgentSessionsPostMutationBody =
  TrainingAgentSessionCreate;
export type CreateSessionApiTrainingAgentSessionsPostMutationError =
  ErrorType<HTTPValidationError>;
export type CreateSessionApiTrainingAgentSessionsPostMutationVariables = {
  data: TrainingAgentSessionCreate;
};

/**
 * @summary Create Session
 */
export const useCreateSessionApiTrainingAgentSessionsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSessionApiTrainingAgentSessionsPost>>,
      TError,
      CreateSessionApiTrainingAgentSessionsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSessionApiTrainingAgentSessionsPost>>,
  TError,
  CreateSessionApiTrainingAgentSessionsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateSessionApiTrainingAgentSessionsPostMutationOptions(options),
    queryClient,
  );
};
export type listSessionsApiTrainingAgentSessionsGetResponse200 = {
  data: TrainingAgentSessionsResponse;
  status: 200;
};

export type listSessionsApiTrainingAgentSessionsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listSessionsApiTrainingAgentSessionsGetResponseSuccess =
  listSessionsApiTrainingAgentSessionsGetResponse200 & {
    headers: Headers;
  };
export type listSessionsApiTrainingAgentSessionsGetResponseError =
  listSessionsApiTrainingAgentSessionsGetResponse422 & {
    headers: Headers;
  };

export type listSessionsApiTrainingAgentSessionsGetResponse =
  | listSessionsApiTrainingAgentSessionsGetResponseSuccess
  | listSessionsApiTrainingAgentSessionsGetResponseError;

export const getListSessionsApiTrainingAgentSessionsGetUrl = (
  params?: ListSessionsApiTrainingAgentSessionsGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/training-agent/sessions?${stringifiedParams}`
    : `/api/training-agent/sessions`;
};

/**
 * The team's sessions, newest first, a page at a time; ``total``
 * counts all of them. The live one is settled first (``_settle_on_read``).
 * @summary List Sessions
 */
export const listSessionsApiTrainingAgentSessionsGet = async (
  params?: ListSessionsApiTrainingAgentSessionsGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listSessionsApiTrainingAgentSessionsGetResponse> => {
  return orvalFetch<listSessionsApiTrainingAgentSessionsGetResponse>(
    getListSessionsApiTrainingAgentSessionsGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListSessionsApiTrainingAgentSessionsGetQueryKey = (
  params?: ListSessionsApiTrainingAgentSessionsGetParams,
) => {
  return [`/api/training-agent/sessions`, ...(params ? [params] : [])] as const;
};

export const getListSessionsApiTrainingAgentSessionsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListSessionsApiTrainingAgentSessionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListSessionsApiTrainingAgentSessionsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>
  > = ({ signal }) =>
    listSessionsApiTrainingAgentSessionsGet(params, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSessionsApiTrainingAgentSessionsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>
>;
export type ListSessionsApiTrainingAgentSessionsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListSessionsApiTrainingAgentSessionsGet<
  TData = Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | ListSessionsApiTrainingAgentSessionsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
          TError,
          Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSessionsApiTrainingAgentSessionsGet<
  TData = Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListSessionsApiTrainingAgentSessionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
          TError,
          Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSessionsApiTrainingAgentSessionsGet<
  TData = Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListSessionsApiTrainingAgentSessionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Sessions
 */

export function useListSessionsApiTrainingAgentSessionsGet<
  TData = Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListSessionsApiTrainingAgentSessionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSessionsApiTrainingAgentSessionsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListSessionsApiTrainingAgentSessionsGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getSessionApiTrainingAgentSessionsSessionIdGetResponse200 = {
  data: TrainingAgentSessionView;
  status: 200;
};

export type getSessionApiTrainingAgentSessionsSessionIdGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getSessionApiTrainingAgentSessionsSessionIdGetResponseSuccess =
  getSessionApiTrainingAgentSessionsSessionIdGetResponse200 & {
    headers: Headers;
  };
export type getSessionApiTrainingAgentSessionsSessionIdGetResponseError =
  getSessionApiTrainingAgentSessionsSessionIdGetResponse422 & {
    headers: Headers;
  };

export type getSessionApiTrainingAgentSessionsSessionIdGetResponse =
  | getSessionApiTrainingAgentSessionsSessionIdGetResponseSuccess
  | getSessionApiTrainingAgentSessionsSessionIdGetResponseError;

export const getGetSessionApiTrainingAgentSessionsSessionIdGetUrl = (
  sessionId: string,
) => {
  return `/api/training-agent/sessions/${sessionId}`;
};

/**
 * One of the team's sessions. The live one is settled first, as for
 * the list, and before this session is read, so the read sees the
 * settle's result.
 * @summary Get Session
 */
export const getSessionApiTrainingAgentSessionsSessionIdGet = async (
  sessionId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getSessionApiTrainingAgentSessionsSessionIdGetResponse> => {
  return orvalFetch<getSessionApiTrainingAgentSessionsSessionIdGetResponse>(
    getGetSessionApiTrainingAgentSessionsSessionIdGetUrl(sessionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSessionApiTrainingAgentSessionsSessionIdGetQueryKey = (
  sessionId: string,
) => {
  return [`/api/training-agent/sessions/${sessionId}`] as const;
};

export const getGetSessionApiTrainingAgentSessionsSessionIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSessionApiTrainingAgentSessionsSessionIdGetQueryKey(sessionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>>
  > = ({ signal }) =>
    getSessionApiTrainingAgentSessionsSessionIdGet(sessionId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSessionApiTrainingAgentSessionsSessionIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>>
  >;
export type GetSessionApiTrainingAgentSessionsSessionIdGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetSessionApiTrainingAgentSessionsSessionIdGet<
  TData = Awaited<
    ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  sessionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSessionApiTrainingAgentSessionsSessionIdGet<
  TData = Awaited<
    ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSessionApiTrainingAgentSessionsSessionIdGet<
  TData = Awaited<
    ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Session
 */

export function useGetSessionApiTrainingAgentSessionsSessionIdGet<
  TData = Awaited<
    ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSessionApiTrainingAgentSessionsSessionIdGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetSessionApiTrainingAgentSessionsSessionIdGetQueryOptions(
      sessionId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetResponse200 =
  {
    data: unknown;
    status: 200;
  };

export type streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetResponseSuccess =
  streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetResponse200 & {
    headers: Headers;
  };
export type streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetResponseError =
  streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetResponse422 & {
    headers: Headers;
  };

export type streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetResponse =

    | streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetResponseSuccess
    | streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetResponseError;

export const getStreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetUrl =
  (
    sessionId: string,
    params?: StreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetParams,
  ) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        normalizedParams.append(key, value === null ? "null" : String(value));
      }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
      ? `/api/training-agent/sessions/${sessionId}/events?${stringifiedParams}`
      : `/api/training-agent/sessions/${sessionId}/events`;
  };

/**
 * The session's events after ``after`` as Server-Sent Events. Each
 * ``data:`` line is one TrainingAgentEventView, and the page reconnects
 * with the last ``seq`` it saw. No request-scoped database session here:
 * the stream would hold its connection for as long as it runs. The
 * events carry the agent's reads of the team's data, so opening the
 * stream is recorded in the team's audit log (TRA-1626).
 * @summary Stream Session Events
 */
export const streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet =
  async (
    sessionId: string,
    params?: StreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetParams,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetResponse> => {
    return orvalFetch<streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetResponse>(
      getStreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetUrl(
        sessionId,
        params,
      ),
      {
        ...options,
        method: "GET",
      },
    );
  };

export const getStreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetQueryKey =
  (
    sessionId: string,
    params?: StreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetParams,
  ) => {
    return [
      `/api/training-agent/sessions/${sessionId}/events`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getStreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
      >
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    sessionId: string,
    params?: StreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getStreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetQueryKey(
        sessionId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
        >
      >
    > = ({ signal }) =>
      streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet(
        sessionId,
        params,
        { signal, ...requestOptions },
      );

    return {
      queryKey,
      queryFn,
      enabled: sessionId !== null && sessionId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type StreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
      >
    >
  >;
export type StreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useStreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet<
  TData = Awaited<
    ReturnType<
      typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  sessionId: string,
  params:
    | undefined
    | StreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet<
  TData = Awaited<
    ReturnType<
      typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  sessionId: string,
  params?: StreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet<
  TData = Awaited<
    ReturnType<
      typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  sessionId: string,
  params?: StreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Stream Session Events
 */

export function useStreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet<
  TData = Awaited<
    ReturnType<
      typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  sessionId: string,
  params?: StreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof streamSessionEventsApiTrainingAgentSessionsSessionIdEventsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getStreamSessionEventsApiTrainingAgentSessionsSessionIdEventsGetQueryOptions(
      sessionId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type sendMessageApiTrainingAgentSessionsSessionIdMessagesPostResponse202 =
  {
    data: TrainingAgentEventView;
    status: 202;
  };

export type sendMessageApiTrainingAgentSessionsSessionIdMessagesPostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type sendMessageApiTrainingAgentSessionsSessionIdMessagesPostResponseSuccess =
  sendMessageApiTrainingAgentSessionsSessionIdMessagesPostResponse202 & {
    headers: Headers;
  };
export type sendMessageApiTrainingAgentSessionsSessionIdMessagesPostResponseError =
  sendMessageApiTrainingAgentSessionsSessionIdMessagesPostResponse422 & {
    headers: Headers;
  };

export type sendMessageApiTrainingAgentSessionsSessionIdMessagesPostResponse =
  | sendMessageApiTrainingAgentSessionsSessionIdMessagesPostResponseSuccess
  | sendMessageApiTrainingAgentSessionsSessionIdMessagesPostResponseError;

export const getSendMessageApiTrainingAgentSessionsSessionIdMessagesPostUrl = (
  sessionId: string,
) => {
  return `/api/training-agent/sessions/${sessionId}/messages`;
};

/**
 * Queue a message for the agent. The runner reads it on its next poll.
 * 409 once the session is over, which a spent budget also ends.
 * @summary Send Message
 */
export const sendMessageApiTrainingAgentSessionsSessionIdMessagesPost = async (
  sessionId: string,
  trainingAgentMessageCreate: TrainingAgentMessageCreate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<sendMessageApiTrainingAgentSessionsSessionIdMessagesPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<sendMessageApiTrainingAgentSessionsSessionIdMessagesPostResponse>(
    getSendMessageApiTrainingAgentSessionsSessionIdMessagesPostUrl(sessionId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(trainingAgentMessageCreate),
    },
  );
};

export const getSendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationKey =
  () => ["sendMessageApiTrainingAgentSessionsSessionIdMessagesPost"] as const;

export const getSendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof sendMessageApiTrainingAgentSessionsSessionIdMessagesPost
        >
      >,
      TError,
      SendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof sendMessageApiTrainingAgentSessionsSessionIdMessagesPost
      >
    >,
    TError,
    SendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getSendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof sendMessageApiTrainingAgentSessionsSessionIdMessagesPost
        >
      >,
      SendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationVariables
    > = (props) => {
      const { sessionId, data } = props ?? {};

      return sendMessageApiTrainingAgentSessionsSessionIdMessagesPost(
        sessionId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof sendMessageApiTrainingAgentSessionsSessionIdMessagesPost
      >
    >
  >;
export type SendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationBody =
  TrainingAgentMessageCreate;
export type SendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationError =
  ErrorType<HTTPValidationError>;
export type SendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationVariables =
  { sessionId: string; data: TrainingAgentMessageCreate };

/**
 * @summary Send Message
 */
export const useSendMessageApiTrainingAgentSessionsSessionIdMessagesPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof sendMessageApiTrainingAgentSessionsSessionIdMessagesPost
        >
      >,
      TError,
      SendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof sendMessageApiTrainingAgentSessionsSessionIdMessagesPost>
  >,
  TError,
  SendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationVariables,
  TContext
> => {
  return useMutation(
    getSendMessageApiTrainingAgentSessionsSessionIdMessagesPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type stopSessionApiTrainingAgentSessionsSessionIdStopPostResponse200 = {
  data: TrainingAgentSessionView;
  status: 200;
};

export type stopSessionApiTrainingAgentSessionsSessionIdStopPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type stopSessionApiTrainingAgentSessionsSessionIdStopPostResponseSuccess =
  stopSessionApiTrainingAgentSessionsSessionIdStopPostResponse200 & {
    headers: Headers;
  };
export type stopSessionApiTrainingAgentSessionsSessionIdStopPostResponseError =
  stopSessionApiTrainingAgentSessionsSessionIdStopPostResponse422 & {
    headers: Headers;
  };

export type stopSessionApiTrainingAgentSessionsSessionIdStopPostResponse =
  | stopSessionApiTrainingAgentSessionsSessionIdStopPostResponseSuccess
  | stopSessionApiTrainingAgentSessionsSessionIdStopPostResponseError;

export const getStopSessionApiTrainingAgentSessionsSessionIdStopPostUrl = (
  sessionId: string,
) => {
  return `/api/training-agent/sessions/${sessionId}/stop`;
};

/**
 * End the session. Its runner exits at its next poll.
 * @summary Stop Session
 */
export const stopSessionApiTrainingAgentSessionsSessionIdStopPost = async (
  sessionId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<stopSessionApiTrainingAgentSessionsSessionIdStopPostResponse> => {
  return orvalFetch<stopSessionApiTrainingAgentSessionsSessionIdStopPostResponse>(
    getStopSessionApiTrainingAgentSessionsSessionIdStopPostUrl(sessionId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getStopSessionApiTrainingAgentSessionsSessionIdStopPostMutationKey =
  () => ["stopSessionApiTrainingAgentSessionsSessionIdStopPost"] as const;

export const getStopSessionApiTrainingAgentSessionsSessionIdStopPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof stopSessionApiTrainingAgentSessionsSessionIdStopPost>
      >,
      TError,
      StopSessionApiTrainingAgentSessionsSessionIdStopPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof stopSessionApiTrainingAgentSessionsSessionIdStopPost>
    >,
    TError,
    StopSessionApiTrainingAgentSessionsSessionIdStopPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getStopSessionApiTrainingAgentSessionsSessionIdStopPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof stopSessionApiTrainingAgentSessionsSessionIdStopPost>
      >,
      StopSessionApiTrainingAgentSessionsSessionIdStopPostMutationVariables
    > = (props) => {
      const { sessionId } = props ?? {};

      return stopSessionApiTrainingAgentSessionsSessionIdStopPost(
        sessionId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type StopSessionApiTrainingAgentSessionsSessionIdStopPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof stopSessionApiTrainingAgentSessionsSessionIdStopPost>
    >
  >;

export type StopSessionApiTrainingAgentSessionsSessionIdStopPostMutationError =
  ErrorType<HTTPValidationError>;
export type StopSessionApiTrainingAgentSessionsSessionIdStopPostMutationVariables =
  { sessionId: string };

/**
 * @summary Stop Session
 */
export const useStopSessionApiTrainingAgentSessionsSessionIdStopPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof stopSessionApiTrainingAgentSessionsSessionIdStopPost>
      >,
      TError,
      StopSessionApiTrainingAgentSessionsSessionIdStopPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof stopSessionApiTrainingAgentSessionsSessionIdStopPost>
  >,
  TError,
  StopSessionApiTrainingAgentSessionsSessionIdStopPostMutationVariables,
  TContext
> => {
  return useMutation(
    getStopSessionApiTrainingAgentSessionsSessionIdStopPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostResponse200 =
  {
    data: TrainingAgentEventView;
    status: 200;
  };

export type decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostResponseSuccess =
  decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostResponse200 & {
    headers: Headers;
  };
export type decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostResponseError =
  decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostResponse422 & {
    headers: Headers;
  };

export type decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostResponse =

    | decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostResponseSuccess
    | decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostResponseError;

export const getDecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostUrl =
  (sessionId: string, approvalId: string) => {
    return `/api/training-agent/sessions/${sessionId}/approvals/${approvalId}`;
  };

/**
 * Approve or decline a request the agent is waiting on. 404 for a
 * request it never made, 409 for one already decided.
 * @summary Decide Approval
 */
export const decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPost =
  async (
    sessionId: string,
    approvalId: string,
    trainingAgentDecision: TrainingAgentDecision,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostResponse> => {
    const getHeaders = (
      h?: NonNullable<RequestInit["headers"]>,
    ): Record<string, string | readonly string[]> => {
      if (!h) return {};
      if (h instanceof Headers) return Object.fromEntries(h.entries());
      if (Symbol.iterator in h) {
        return Object.fromEntries(
          Array.from(
            h as Iterable<Iterable<string>>,
            (entry) => Array.from(entry) as [string, string],
          ),
        );
      }
      const headers: Record<string, string | readonly string[]> = {};
      for (const [name, value] of Object.entries<
        string | readonly string[] | undefined
      >(h)) {
        if (value !== undefined) headers[name] = value;
      }
      return headers;
    };
    return orvalFetch<decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostResponse>(
      getDecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostUrl(
        sessionId,
        approvalId,
      ),
      {
        ...options,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(options?.headers),
        },
        body: JSON.stringify(trainingAgentDecision),
      },
    );
  };

export const getDecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationKey =
  () =>
    [
      "decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPost",
    ] as const;

export const getDecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPost
        >
      >,
      TError,
      DecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPost
      >
    >,
    TError,
    DecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getDecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPost
        >
      >,
      DecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationVariables
    > = (props) => {
      const { sessionId, approvalId, data } = props ?? {};

      return decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPost(
        sessionId,
        approvalId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPost
      >
    >
  >;
export type DecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationBody =
  TrainingAgentDecision;
export type DecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationError =
  ErrorType<HTTPValidationError>;
export type DecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationVariables =
  { sessionId: string; approvalId: string; data: TrainingAgentDecision };

/**
 * @summary Decide Approval
 */
export const useDecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPost =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPost
          >
        >,
        TError,
        DecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof decideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPost
      >
    >,
    TError,
    DecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationVariables,
    TContext
  > => {
    return useMutation(
      getDecideApprovalApiTrainingAgentSessionsSessionIdApprovalsApprovalIdPostMutationOptions(
        options,
      ),
      queryClient,
    );
  };
export type decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostResponse200 =
  {
    data: TrainingAgentEventView;
    status: 200;
  };

export type decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostResponseSuccess =
  decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostResponse200 & {
    headers: Headers;
  };
export type decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostResponseError =
  decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostResponse422 & {
    headers: Headers;
  };

export type decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostResponse =

    | decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostResponseSuccess
    | decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostResponseError;

export const getDecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostUrl =
  (sessionId: string, requestId: string) => {
    return `/api/training-agent/sessions/${sessionId}/launch-requests/${requestId}`;
  };

/**
 * Approve or decline a launch the agent asked for (TRA-1326). Approve
 * launches it through the Training page's launch path as the approver,
 * with the run linked to the session and the request, and the agent reads
 * the outcome: the run id, or why the launch was refused. 404 for a
 * request the agent never made, 409 for one decided or still launching.
 *
 * An approval whose launch never reported back (the api died mid-launch)
 * expires, and the request can then be decided again (TRA-1347). A run
 * the first attempt started is its outcome, whichever the decision, so
 * nothing launches twice.
 * @summary Decide Launch Request
 */
export const decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPost =
  async (
    sessionId: string,
    requestId: string,
    trainingAgentLaunchDecision: TrainingAgentLaunchDecision,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostResponse> => {
    const getHeaders = (
      h?: NonNullable<RequestInit["headers"]>,
    ): Record<string, string | readonly string[]> => {
      if (!h) return {};
      if (h instanceof Headers) return Object.fromEntries(h.entries());
      if (Symbol.iterator in h) {
        return Object.fromEntries(
          Array.from(
            h as Iterable<Iterable<string>>,
            (entry) => Array.from(entry) as [string, string],
          ),
        );
      }
      const headers: Record<string, string | readonly string[]> = {};
      for (const [name, value] of Object.entries<
        string | readonly string[] | undefined
      >(h)) {
        if (value !== undefined) headers[name] = value;
      }
      return headers;
    };
    return orvalFetch<decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostResponse>(
      getDecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostUrl(
        sessionId,
        requestId,
      ),
      {
        ...options,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(options?.headers),
        },
        body: JSON.stringify(trainingAgentLaunchDecision),
      },
    );
  };

export const getDecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationKey =
  () =>
    [
      "decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPost",
    ] as const;

export const getDecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPost
        >
      >,
      TError,
      DecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPost
      >
    >,
    TError,
    DecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getDecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPost
        >
      >,
      DecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationVariables
    > = (props) => {
      const { sessionId, requestId, data } = props ?? {};

      return decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPost(
        sessionId,
        requestId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPost
      >
    >
  >;
export type DecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationBody =
  TrainingAgentLaunchDecision;
export type DecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationError =
  ErrorType<HTTPValidationError>;
export type DecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationVariables =
  { sessionId: string; requestId: string; data: TrainingAgentLaunchDecision };

/**
 * @summary Decide Launch Request
 */
export const useDecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPost =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPost
          >
        >,
        TError,
        DecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof decideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPost
      >
    >,
    TError,
    DecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationVariables,
    TContext
  > => {
    return useMutation(
      getDecideLaunchRequestApiTrainingAgentSessionsSessionIdLaunchRequestsRequestIdPostMutationOptions(
        options,
      ),
      queryClient,
    );
  };
